import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import {postRequest} from "../routes/Routes";
import Expand from 'react-expand-animated';
import {getUser} from "../auth/Auth";
import '../assets/css/Home.css';
import Loading from "../components/Loading";

class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {orders: [], user: null, loading: true};
    }

    componentDidMount() {
        getUser(this.props.history).then(data => {
            this.setState({user: data});
            this.loadOrders();
        });
    }

    render() {
        if (this.state.user) {
            return (
                this.state.loading ?
                    <Loading/>
                    : <div className="container category-list partner-list">
                        <div className="d-flex bd-highlight w-100 contact-us-details">
                            <div className="p-2 flex-fill bd-highlight">
                                <h1 className="heading">Orders</h1>
                            </div>
                        </div>
                        <hr/>
                        {this.state.orders.length > 0 ? this.getOrderBody() : "No Orders"}
                    </div>
            );
        } else {
            return null;
        }
    }

    getOrderBody = () => {
        let orderBody = [];
        this.state.orders.forEach((order, index) => {
            orderBody.push(
                <div key={index}>
                    <div className="d-flex bd-highlight w-100 order order-container"
                         onClick={() => this.expandProduct(index)}>
                        <div className="p-2 flex-fill bd-highlight">
                            <h4>Order No: <strong>{order.reference}</strong></h4>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>
                                Date: <strong>{new Date(order.created_at).toDateString()}</strong>
                            </div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Service Charge: <strong>Rs.{order.service_charge}</strong></div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Total: <strong>Rs.{order.sub_total + order.service_charge}</strong></div>
                        </div>
                    </div>
                    <Expand open={order.open}>
                        <div className="order-container">
                            Address: <strong>{order.address + ', ' + order.city}</strong><br/>
                            Phone: <strong>{order.phone}</strong><br/>
                            Notes: <strong>{order.notes}</strong>
                        </div>
                        <div className="order-container">
                            {this.getProductBody(order.order_products)}
                        </div>
                    </Expand>
                </div>
            )
        });

        return orderBody;
    };

    getProductBody = (products) => {
        let productBody = [];
        products.forEach((product, index) => {
            productBody.push(
                <div key={index}>
                    <div className="d-flex bd-highlight w-100 order-container order-product-container">
                        <div className="p-2 flex-fill bd-highlight">
                            <h4>Product: <strong>{product.product.name}</strong></h4>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Store Name: <strong>{product.product.partner.name}</strong></div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Quantity: <strong>{product.quantity}</strong></div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Unit Price: <strong>Rs.{product.price}</strong></div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Total: <strong>Rs.{product.price * product.quantity}</strong></div>
                        </div>
                    </div>
                </div>
            )
        });

        return productBody;
    };

    loadOrders = () => {
        let {orders, user} = this.state;
        postRequest({
            email: user.email,
            endpoint: '/api/users/orders',
            token: this.state.user.api_token
        }).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    response.data.orders.forEach((order) => {
                        order.open = false;
                        orders.push(order);
                    });
                    this.setState({orders: orders, loading: false});
                }
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    };

    expandProduct = (index) => {
        let {orders} = this.state;
        orders[index].open = !orders[index].open;
        this.setState({orders: orders});
    };
}

export default withAlert()(withRouter(Account));
